var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoutenluikenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "259.797px",
    height: "661.167px",
    viewBox: "273.408 66.724 259.797 661.167",
    enableBackground: "new 273.408 66.724 259.797 661.167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.031,
    y: 66.8,
    fill: "#FFFFFF",
    width: 258.454,
    height: 28.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.498,
    y: 66.724,
    fill: "#FFFFFF",
    width: 28.707,
    height: 661.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.408,
    y: 66.724,
    fill: "#FFFFFF",
    width: 28.707,
    height: 661.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.031,
    y: 699.184,
    fill: "#FFFFFF",
    width: 258.828,
    height: 28.707
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,156.031 322.655,133.727 475.982,133.727 484.482,156.031  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.22,
    y: 374.904,
    fill: "#FFFFFF",
    width: 258.454,
    height: 37.192
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,204.222 322.655,181.917 475.982,181.917 484.482,204.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,249.543 322.655,227.239 475.982,227.239 484.482,249.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,292.777 322.655,270.473 475.982,270.473 484.482,292.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,337.932 322.655,315.627 475.982,315.627 484.482,337.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,475.492 322.655,453.188 475.982,453.188 484.482,475.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,523.684 322.655,501.379 475.982,501.379 484.482,523.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,569.005 322.655,546.7 475.982,546.7 484.482,569.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,612.239 322.655,589.935 475.982,589.935 484.482,612.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "331.155,657.394 322.655,635.089 475.982,635.089 484.482,657.394  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoutenluikenIcon);
export default __webpack_public_path__ + "static/media/houtenluiken-icon.638917b804efd45cd264c3a104541e34.svg";
export { ForwardRef as ReactComponent };